module.exports = require("react-dev-utils/typescriptFormatter");